import getHashFromUrlLocationUtil from 'utils/location/get-hash-value-from-url'
import logUtil from 'utils/log'
import replaceStateHistoryUtil from 'utils/history/replace-state'
import getPathnameWithQueryLocationUtil from 'utils/location/get-pathname-with-query'

export default function removeHashLocationUtil () {
  logUtil('removeHashLocationUtil').debug('[start]')

  const hash = getHashFromUrlLocationUtil()
  if (!hash) {
    logUtil('removeHashLocationUtil').debug('[noop] no hash')
    return
  }

  replaceStateHistoryUtil(
    getPathnameWithQueryLocationUtil()
  )
  logUtil('removeHashLocationUtil').debug('[done]')
}
